import React from 'react';
import { Sprout } from 'lucide-react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md z-50 border-b border-emerald-100" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="flex justify-between items-center h-16" data-id="element-42">
          <div className="flex items-center gap-2" data-id="element-43">
            <div className="bg-emerald-100 p-2 rounded-lg" data-id="element-44">
              <Sprout className="h-6 w-6 text-emerald-600" data-id="element-45" />
            </div>
            <span className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-46">
              Playcraft
            </span>
          </div>

          <nav className="hidden md:flex items-center gap-8" data-id="element-47">
            <a href="#how-it-works" className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-48">
              How it Works
            </a>
            <a href="#services" className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-49">
              Services
            </a>
            <a href="#why-us" className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-50">
              Why Us
            </a>
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-full font-medium transition-all hover:shadow-lg hover:shadow-emerald-200 transform hover:-translate-y-0.5" data-id="element-51">
              Start Learning
            </button>
          </nav>

          <button className="md:hidden text-gray-600" data-id="element-52">
            <span className="sr-only" data-id="element-53">Open menu</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-54">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-55" />
            </svg>
          </button>
        </div>
      </div>
    </header>;
}